import { Api } from '@/api';
import { toast } from 'vue-sonner';
import type { Ref } from 'vue';
import type { ContactDetail } from '../ContactDetail';

export const useReapplyToggle = (contact: Ref<ContactDetail | null>) => {
  const updateReapplyAllowed = async (value: boolean) => {
    const current = contact.value;
    if (!current) return;

    const previous = current.reapplyAllowed;
    current.reapplyAllowed = value;

    const response = await Api.Contacts.updateContact({
      contactId: current.id,
      payload: { reapply_allowed: value },
    });

    if (response.status === 'error') {
      current.reapplyAllowed = previous;
      toast.error('Failed to update reapplication setting', { description: response.message });
      return;
    }

    toast.success(value ? 'Candidate can reapply to other roles' : 'Candidate blocked from reapplying');
  };

  return { updateReapplyAllowed };
};
